<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('SAGTWL', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['SAGTWLD']}}</h2>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}}</span>
                                <customtreeselect :multiple="false"
                                            :flat="true"
                                            :load-options="loadAgentOptions"
                                            :options="ddAgentList"
                                            :auto-load-root-options="convertToBool(searchAgent)"
                                            :defaultExpandLevel="Infinity"
                                            @input="selectAgentOptions"
                                            :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                            v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :options="ddSubAgentList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            @input="selectSubAgentOptions" />

                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :load-options="loadGameProviderOptions"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :options="ddGameProviderList"
                                            :auto-load-root-options="true"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="searchCreatedTS"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchCreatedTS.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                                <treeselect :key="dd_memberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchUserId > 0 && searchUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            @input="selectMemberOptions"
                                            @deselect="deSelectMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["RU"]}} :</span>
                                <treeselect :key="dd_referralMemberKey"
                                            :multiple="false"
                                            :async="true"
                                            :load-options="loadReferralMemberOptions"
                                            :options="ddReferralMemberList"
                                            :defaultOptions="ddDefaultMemberList"
                                            :auto-load-root-options="convertToBool(searchReferralUserId > 0 && searchReferralUsername)"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.RU')"
                                            @input="selectReferralMemberOptions"
                                            @deselect="deSelectReferralMemberOptions"
                                            :cacheOptions="false"
                                            v-model="searchReferralUserId" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrency"
                                            @input="updateCC()" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddCurrencyList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="searchCurrencyFilter" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{getLanguage["MT"]["VDP"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="arry_vdp"
                                            placeholder
                                            v-model="searchVDP" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newsearch()" class='searchBtn' ref="search" size="sm" block color="success" @click=" newsearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        
            <div class='table-wrapper'>
                <header class="table-header d-flex">
                    <div class="d-flex align-items-center">
                        <strong v-if="getUserInfo.AT === 4" id="titleHeight">{{ getLanguage["SMB"]["NTWL"] }}</strong>
                        <strong v-else id="titleHeight">{{this.getLanguage['SMB']['SAGTWL']}}</strong>
                        <div class="ml-2">
                            <!--<CButton color="outline-primary" size="sm" @click="SignOff()">
                                <span class='plusIcon cil-lock-locked'></span>{{this.getLanguage["FR"]["SOFF"]}}
                            </CButton>-->
                            <CButton v-if="arr_reportList.length >= 2 && arr_reportList[1].PN == null && ML_D" class="btnExcel" @click="saveBlackList()">
                                <i class="cil-ban" width="20" style="padding-left:2px"></i>
                                {{this.getLanguage["BTN"]["BLK"]}}
                            </CButton>
                            <CButton v-if="arr_reportList.length >= 2 && arr_reportList[1].PN == null && ML_D" class="btnExcel" @click="saveFreeze()">
                                <i class="cil-snowflake" width="20" style="padding-left:2px"></i>
                                {{this.getLanguage["BTN"]["FK"]}}
                            </CButton>
                            <span v-if="convertToBool(objPayoutScheme)">
                                <span>(<strong>{{getLanguage["SAPS"]["SC"]}}</strong>:{{utilGetErrorLanguage('SAPS.TYP' + objPayoutScheme.POT)}} </span>
                                <span> <strong>{{getLanguage["SAPS"]["TYP"]}}</strong>:{{utilGetErrorLanguage('SAPS.SC' + objPayoutScheme.WLT)}})</span>
                            </span>
                        </div>
                    </div>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                        <button @click="ctrPage(+int_Page - 1)"  v-if="searchGameProviderId.length >= 1">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)"
                                v-if="searchGameProviderId.length >= 1" />
                        <span class="tableItemCount"  v-if="searchGameProviderId.length >= 1">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)"  v-if="searchGameProviderId.length >= 1">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2">{{this.getLanguage['MEM']['CKMPVD']}}/ <span class="tableCtnRight">{{this.getLanguage['MEM']['U']}}</span><i @click="setSortTable('PN')" class="sortlogo" :class="setSortLogo('PN')"></i></th>
                                <th rowspan="2">{{this.getLanguage['MEM']['CI']}}</th>
                                <th rowspan="2">{{this.getLanguage['MEM']['ACTM']}}<i @click="setSortTable('MUC')" class="sortlogo" :class="setSortLogo('MUC')"></i></th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171); background: #1a5a0d !important">{{this.getLanguage["BETRPT"]["DPT"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171); background: #810a0a !important;">{{this.getLanguage["BETRPT"]["WTH"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["ADJM"]}}</th>
                                <th colspan="4" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["BET"]}}</th>
                                <th rowspan="2">{{this.getLanguage['BETRPT']['AWR']}}<i @click="setSortTable('AWR')" class="sortlogo" :class="setSortLogo('AWR')"></i></th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); background: #004698 !important">{{this.getLanguage["BETRPT"]["PK"]}}</th>
                                <th colspan="4" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["SHR"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["BNS"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["ARB"]}}</th>
                                <!--<th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AFF"]}}</th>-->
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["DLS"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["RFF"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["TNMT"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["SMB"]["MSA"]}}</th>
                                <!--<th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["SAG"]}}</th>-->
                                <th rowspan="2" style="background: #562c87 !important;">{{(arr_mainReportList.SAGPT == 2) ? this.getLanguage["BETRPT"]["GWL"] : this.getLanguage["BETRPT"]["TWL"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #1a5a0d !important;">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #1a5a0d !important;">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #810a0a !important;">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #810a0a !important;">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#<i @click="setSortTable('BC')" class="sortlogo" :class="setSortLogo('BC')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}<i @click="setSortTable('BA')" class="sortlogo" :class="setSortLogo('BA')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["TRO"]}}<i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["WNL"]}}<i @click="setSortTable('WLA')" class="sortlogo" :class="setSortLogo('WLA')"></i></th>

                                <!-- Poker -->
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171); background: #004698 !important">{{this.getLanguage["BETRPT"]["WL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171); background: #004698 !important">{{this.getLanguage["BETRPT"]["AGC"]}}</th>

                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["PPT"]["PPT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["WLBMRPT"]["PWL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["APT"]["APT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["WLBMRPT"]["AWL"]}}<i @click="setSortTable('AWL')" class="sortlogo" :class="setSortLogo('AWL')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <!--<th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
            <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>-->
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th rowspan="2">{{this.getLanguage["GL"]["NO"]}}</th>
                                <th rowspan="2">{{this.getLanguage['MEM']['CKMPVD']}}/ <span class="tableCtnRight">{{this.getLanguage['MEM']['U']}}</span><i @click="setSortTable('PN')" class="sortlogo" :class="setSortLogo('PN')"></i></th>
                                <th rowspan="2">{{this.getLanguage['MEM']['CI']}}</th>
                                <th rowspan="2">{{this.getLanguage['MEM']['ACTM']}}<i @click="setSortTable('MUC')" class="sortlogo" :class="setSortLogo('MUC')"></i></th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171); background: #1a5a0d !important">{{this.getLanguage["BETRPT"]["DPT"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171); background: #810a0a !important;">{{this.getLanguage["BETRPT"]["WTH"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.8px solid rgb(157, 157, 171); border-left: 1.8px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["ADJM"]}}</th>
                                <th colspan="4" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["BET"]}}</th>
                                <th rowspan="2">{{this.getLanguage['BETRPT']['AWR']}}<i @click="setSortTable('AWR')" class="sortlogo" :class="setSortLogo('AWR')"></i></th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); background: #004698 !important">{{this.getLanguage["BETRPT"]["PK"]}}</th>
                                <th colspan="4" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["SHR"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["BNS"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["ARB"]}}</th>
                                <!--<th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AFF"]}}</th>-->
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["DLS"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["RFF"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["TNMT"]}}</th>
                                <th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["SMB"]["MSA"]}}</th>
                                <!--<th colspan="2" id="nestedTable" style="border-bottom: 1.5px solid rgb(157, 157, 171); border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["SAG"]}}</th>-->
                                <th rowspan="2" style="background: #562c87 !important;">{{(arr_mainReportList.SAGPT == 2) ? this.getLanguage["BETRPT"]["GWL"] : this.getLanguage["BETRPT"]["TWL"]}}</th>
                            </tr>
                            <tr>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #1a5a0d !important;">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #1a5a0d !important;">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #810a0a !important;">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.8px solid rgb(157, 157, 171); background: #810a0a !important;">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#<i @click="setSortTable('BC')" class="sortlogo" :class="setSortLogo('BC')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}<i @click="setSortTable('BA')" class="sortlogo" :class="setSortLogo('BA')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["TRO"]}}<i @click="setSortTable('TA')" class="sortlogo" :class="setSortLogo('TA')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["WNL"]}}<i @click="setSortTable('WLA')" class="sortlogo" :class="setSortLogo('WLA')"></i></th>

                                <!-- Poker -->
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171); background: #004698 !important">{{this.getLanguage["BETRPT"]["WL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171); background: #004698 !important">{{this.getLanguage["BETRPT"]["AGC"]}}</th>

                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["PPT"]["PPT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["WLBMRPT"]["PWL"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["APT"]["APT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["WLBMRPT"]["AWL"]}}<i @click="setSortTable('AWL')" class="sortlogo" :class="setSortLogo('AWL')"></i></th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
                                <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>
                                <!--<th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171);">#</th>
    <th id="nestedTableR2" class="textAlignCenter" style="border-left: 1.5px solid rgb(157, 157, 171); border-right: 1.5px solid rgb(157, 157, 171);">{{this.getLanguage["BETRPT"]["AMT"]}}</th>-->
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="is_loaded">
                                <tr>
                                    <td class="tableCtnRight stickyLeft">1</td>
                                    <td class="stickyLeft">MAIN WALLET</td>
                                    <td class="stickyLeft">{{ arr_mainReportList.ISOC }}</td>
                                    <td>{{ formatNumber(arr_mainReportList.AM, 0) }}</td>
                                    <td class="tableCtnRight depositBg">{{ formatNumber(arr_mainReportList.TDC, 0) }}</td>
                                    <td :class="arr_mainReportList.TDA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight depositBg">{{ formatNumber(arr_mainReportList.TDA, 2) }}</td>
                                    <td class="tableCtnRight withdrawBg">{{ formatNumber(arr_mainReportList.TWC, 0) }}</td>
                                    <td class="tableCtnRight withdrawBg negative-number">{{ formatNumber(arr_mainReportList.TWA, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TADC, 0) }}</td>
                                    <td :class="arr_mainReportList.TADA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(arr_mainReportList.TADA, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(totalBet, 0) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(totalBetAmount, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(totalBetTurnover, 2) }}</td>
                                    <td :class="totalBetWL >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(totalBetWL, 2) }}</td>
                                    <!--Margin-->
                                    <td :class="MarginCal(totalBetWL,totalBetTurnover) < 0 ? 'negative-number': 'positive-number'" v-if="totalBetTurnover > 0" class="tableCtnRight">{{ formatNumber(MarginCal(totalBetWL,totalBetTurnover), 2, "") }}%</td>
                                    <td class="tableCtnRight" v-else>-</td>
                                    <!--Poker Member W/L-->
                                    <td class="tableCtnRight">
                                        <span v-if="arr_mainReportList.PMWL != null && arr_mainReportList.PMWL != 0"
                                              :class="arr_mainReportList.PMWL >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(arr_mainReportList.PMWL, 2) }}
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <!--Poker Agent com-->
                                    <td class="tableCtnRight">
                                        <span v-if="arr_mainReportList.W1AC != null && arr_mainReportList.W1AC != 0"
                                              :class="arr_mainReportList.W1AC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(arr_mainReportList.W1AC, 2) }}
                                        </span>
                                        <span v-else>-</span>
                                    </td>

                                    <td class="tableCtnRight">{{formatNumber(arr_mainReportList.PPT, 2)}}</td>
                                    <td :class="totalBetPWL >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(totalBetPWL, 2) }}</td>
                                    <td class="tableCtnRight">{{formatNumber(arr_mainReportList.ADPT, 2)}}</td>
                                    <td :class="totalBetHWL >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(totalBetHWL, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TBC, 0) }}</td>
                                    <td class="tableCtnRight" :class="arr_mainReportList.TBA * -1 >= 0? 'positive-number': 'negative-number'">{{ formatNumber(arr_mainReportList.TBA * -1, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TARC, 0) }}</td>
                                    <td class="tableCtnRight" :class="arr_mainReportList.TARA * -1 >= 0? 'positive-number': 'negative-number'">{{ formatNumber(arr_mainReportList.TARA * -1, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TDLSC, 0) }}</td>
                                    <td class="tableCtnRight" :class="arr_mainReportList.TDLSA * -1 >= 0? 'positive-number': 'negative-number'">{{ formatNumber(arr_mainReportList.TDLSA * -1, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TRC, 0) }}</td>
                                    <td class="tableCtnRight" :class="arr_mainReportList.TRA * -1 >= 0? 'positive-number': 'negative-number'">{{ formatNumber(arr_mainReportList.TRA * -1, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TTC, 0) }}</td>
                                    <td class="tableCtnRight" :class="arr_mainReportList.TTA * -1 >= 0? 'positive-number': 'negative-number'">{{ formatNumber(arr_mainReportList.TTA * -1, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(arr_mainReportList.TPC, 0) }}</td>
                                    <td class="tableCtnRight" :class="arr_mainReportList.TPA * -1 >= 0? 'positive-number': 'negative-number'">{{ formatNumber(arr_mainReportList.TPA * -1, 2) }}</td>
                                    <td :class="calculateTWL(totalBetHWL, arr_mainReportList.W1AC, arr_mainReportList.TBA, arr_mainReportList.TARA, arr_mainReportList.TDLSA, arr_mainReportList.TRA, arr_mainReportList.TTA, arr_mainReportList.TPA, arr_mainReportList.ADPT) >= 0? 'positive-number': 'negative-number'" class="tableCtnRight winlossBg">
                                        {{ formatNumber(calculateTWL(totalBetHWL, arr_mainReportList.W1AC, arr_mainReportList.TBA, arr_mainReportList.TARA, arr_mainReportList.TDLSA, arr_mainReportList.TRA, arr_mainReportList.TTA, arr_mainReportList.TPA, arr_mainReportList.ADPT) , 2) }}
                                    </td>
                                </tr>
                            </template>
                            <td colspan="100%" v-if="!is_loaded && arr_reportList.length == 0">{{this.getLanguage['GL']['PCSFR']}}</td>
                            <td colspan="100%" v-else-if="is_loaded && arr_reportList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                            <template v-for="(data,index) in arr_reportList" v-if="data.PN != null || arr_displayGPI.includes(data.GPI)">
                                <tr :class="data.PN == null ? data.RS == 1 ? 'blacklist-row': data.RS == 3? 'freeze-row': '': ''">
                                    <td class="tableCtnRight stickyLeft">
                                        <input v-if="!(arr_reportList.find(o=>o.PN==null) == undefined) && data.PN != null && ML_D" type="checkbox" @click="changeAlllCheckBox()" v-model="arr_reportList[0].isChecked" />
                                        <input v-if="!(arr_reportList.find(o=>o.PN==null) == undefined) && data.PN == null && ML_D" type="checkbox" :value="data.isChecked" v-model="data.isChecked" />
                                        <span v-if="data.I==0">{{ index+2 }}</span>
                                        <span v-else>{{ CountItem(index) }}</span>
                                    </td>
                                    <td :class="data.PN != null ? 'kema-eft stickyLeft' : ''" @click="DisplayGPI(data.GPI, data.PN)">
                                        <span v-if="data.PN != null">{{ renderProviderName(data.PN) }}</span>
                                        <span v-if="data.PN == null" class="tableCtnRight">
                                            <div class="custom-tooltip">
                                                {{data.U}}
                                            </div>
                                        </span>
                                    </td>
                                    <td class="stickyLeft">{{ data.ISOC }}</td>
                                    <td>
                                        <span v-if="data.PN != null && data.MUC > 0">{{ formatNumber(data.MUC, 0) }}</span>
                                        <span v-else>-</span>
                                    </td>
                                    <td class="tableCtnRight depositBg">-</td>
                                    <td class="tableCtnRight depositBg">-</td>
                                    <td class="tableCtnRight withdrawBg">-</td>
                                    <td class="tableCtnRight withdrawBg">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">{{ formatNumber(data.BC, 0) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data.BA, 2) }}</td>
                                    <td class="tableCtnRight">{{ formatNumber(data.TA, 2) }}</td>
                                    <td :class="data.WLA >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.WLA, 2) }}</td>
                                    <!--Margin-->
                                    <td :class="MarginCal(data.WLA,data.TA) < 0 ? 'negative-number': 'positive-number'" v-if="data.TA > 0" class="tableCtnRight">{{ formatNumber(MarginCal(data.WLA,data.TA), 2, "") }}%</td>
                                    <td class="" v-else>-</td>
                                    <!--Poker Member W/L-->
                                    <td class="tableCtnRight">
                                        <span v-if="data.PMWL != null && data.PMWL != 0"
                                              :class="data.PMWL >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.PMWL, 2) }}
                                        </span>
                                        <span v-else>-</span>
                                    </td>
                                    <!--Poker Agent com-->
                                    <td class="tableCtnRight">
                                        <span v-if="data.W1AC != null && data.W1AC != 0"
                                              :class="data.W1AC >= 0? 'positive-number': 'negative-number'">
                                            {{ formatNumber(data.W1AC, 2) }}
                                        </span>
                                        <span v-else>-</span>
                                    </td>

                                    <td class="tableCtnRight">{{formatNumber(data.PWLS, 2)}}</td>
                                    <td :class="data.PWL >= 0? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(data.PWL, 2) }}</td>
                                    <td class="tableCtnRight">{{formatNumber(data.APT, 2)}}</td>
                                    <td :class="(parseFloat(data.WWL)) >= 0 ? 'positive-number': 'negative-number'" class="tableCtnRight">{{ formatNumber(parseFloat(data.WWL), 2) }}</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td class="tableCtnRight">-</td>
                                    <td :class="(parseFloat(data.SAGWL)) >= 0? 'positive-number': 'negative-number'" class="tableCtnRight winlossBg">{{ formatNumber(parseFloat(data.SAGWL), 2) }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { mapGetters, mapActions } from 'vuex';
    import Vue from 'vue'
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading
        },
        data() {
            return {
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_firstLogin: false,
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                ddSubAgentList: null,
                ddDefaultSubBrand: null,
                ddGameProviderList: null,
                ddMemberList: null,
                ddDefaultMemberList: null,
                ddReferralMemberList: null,
                ddReferralDefaultMemberList: null,
                ddCurrencyList: null,
                // search fields
                searchAgi: '',
                searchAgent: null,
                searchSubAgent: null,
                searchUserId: null,
                searchUsername: null,
                searchReferralUserId: null,
                searchReferralUsername: null,
                searchGameProviderId: [],
                searchCurrency: null,
                searchCurrencyFilter: null,
                searchCreatedTS: { startDate: this.getMonthStartDate(), endDate: this.getMonthEndDate() },
                arr_mainReportList: [],
                arr_reportList: [],
                arr_displayGPI: [],
                dd_memberKey: 0,
                dd_referralMemberKey: 0,
                sc_userid: 0,
                sc_username: null,
                sc_daterange: { startDate: null, endDate: null },
                sc_cur: null,
                sc_curf: null,
                sc_agi: null,
                sc_agent: null,
                shareIndicator: "",
                constAccessType: constAccessType,
                totalBet: 0,
                totalBetAmount: 0,
                totalBetTurnover: 0,
                totalBetWL: 0,
                totalBetPWL: 0,
                totalBetHWL: 0,
                totalWL: 0,     //Total Net/Gross Win/Loss
                ML_D: false,
                is_loaded: false,
                str_tableSortBy: "TA", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending,
                int_TP: 1,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_RC: 100,
                objPayoutScheme: { POT: null, WLT: null },
                rtSubBrand: 0,
                hideBrand: false,
                arry_vdp: [{ id: "", label: "All" }, { id: "1", label: "Yes" }, { id: "0", label: "No" }],
                searchVDP: null,
                searchGameCategoryIds: null,
            }
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchCreatedTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchCreatedTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchCreatedTS.endDate = "";
                    }
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = that.deepClone(d.dropdownlist);
                            if (that.ddAgentList.length > 0) {
                                that.ddAgentList.forEach(that.disableAgentGroupParent);
                            }
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            selectAgentOptions(value, instanceId) {
                this.searchAgi = 0;
                if (value) {
                    this.searchAgi = value.split("-")[1];
                    this.searchSubAgent = null;

                } else {
                    this.searchAgent = null;
                    this.searchSubAgent = null;
                }
            },
            selectSubAgentOptions(value, instanceId) {
                this.searchAgi = 0;
                if (value) {
                    this.searchAgi = value;
                } else {
                    this.searchSubAgent = null;
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    parentAGI = this.searchAgent.split("-")[1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                            that.getReportList();
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            selectGameProvider(value, instanceId) {

            },
            loadGameProviderOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                        else {
                            that.ddGameProviderList = null;
                        }
                        callback();
                        //if (that.searchGameProviderId > 0) {
                        //    that.selectGameProvider(that.searchGameProviderId);
                        //}
                    });
            },
            newsearch() {
                this.$refs.search.focus();
                if (this.searchCreatedTS) {
                    if (this.searchCreatedTS.startDate != "") {
                        var z = this.set90daysDateSearch(this.searchCreatedTS.startDate);
                        if (z == true) {
                            return;
                        }
                    }
                }
                this.getReportList();
            },
            getReportList() {
                this.is_loaded = true;
                var that = this;
                var path = "";
                this.arr_mainReportList = [];
                this.arr_reportList = [];

                //var path = '';
                var hasDefaultPath = false;
                path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                if (path) {
                    hasDefaultPath = true;
                }

                path += "&f.FSAR=true";

                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                    path += "&f.AGT=4";
                }
                else if (this.searchAgent){
                    path += "&f.AGI=" + this.searchAgent.split("-")[1];
                    path += "&f.AGT=3";
                }

                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }

                if (this.searchGameCategoryIds) {
                    path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                }

                if (this.searchGameProviderId) {
                    //path += "&f.GPI=" + this.searchGameProviderId;
                    path += "&f.GPI_csv=" + this.searchGameProviderId;
                }
                else {
                    this.arr_displayGPI = [];
                }

                if (this.searchCurrency && this.bool_firstLogin == true) {
                    path += "&f.CI=" + this.searchCurrency;
                }
                else if (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) {
                    path += "&f.CI=" + localStorage.getItem('CCUSD');
                    this.bool_firstLogin = true;
                }

                if (this.searchCurrencyFilter) {
                    path += "&f.CIF=" + this.searchCurrencyFilter;
                }

                if (this.searchCreatedTS) {

                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }

                }

                if (this.arr_displayGPI.length > 0) {
                    path += "&f.ID=1";
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                this.objPayoutScheme = { POT: null, WLT: null };
                this.bool_fullLoading = true;

                this.getDataApi(`/api/reports/winloss/totalbsagd?${path}`,
                    function (d, s) {
                        if (s) {
                            that.temp_providerName = null;
                            that.sc_userid = that.searchUserId;
                            that.sc_username = that.searchUsername;
                            that.sc_daterange = that.searchCreatedTS;
                            that.sc_cur = that.searchCurrency;
                            that.sc_curf = that.searchCurrencyFilter;
                            that.sc_agi = that.searchAgi;
                            that.sc_agent = that.searchAgent;

                            if (d.Item1) {
                                that.arr_mainReportList = d.Item1;
                            } else {
                                that.arr_mainReportList = [];
                            }

                            if (d.Item2 && d.Item2.D && d.Item2.D.Items) {
                                var temp_providerName = null;
                                for (var i = 0; i < d.Item2.D.Items.length; i++) {
                                    if (temp_providerName == d.Item2.D.Items[i].PN) {
                                        temp_providerName = d.Item2.D.Items[i].PN;
                                        d.Item2.D.Items[i].PN = null;
                                    }
                                    else {
                                        temp_providerName = d.Item2.D.Items[i].PN;
                                    }
                                }

                                that.totalBet = 0;
                                that.totalBetAmount = 0;
                                that.totalBetTurnover = 0;
                                that.totalBetWL = 0;
                                that.totalBetPWL = 0;
                                that.totalBetHWL = 0;

                                for (var i = 0; i < d.Item2.D.Items.length; i++) {
                                    if (d.Item2.D.Items[i].PN != null) {
                                        that.totalBet += parseFloat(d.Item2.D.Items[i].BC);
                                        that.totalBetAmount += parseFloat(d.Item2.D.Items[i].BA);
                                        that.totalBetTurnover += parseFloat(d.Item2.D.Items[i].TA);
                                        that.totalBetWL += parseFloat(d.Item2.D.Items[i].WLA);
                                        that.totalBetPWL += parseFloat(d.Item2.D.Items[i].PWL);
                                        that.totalBetHWL += parseFloat(d.Item2.D.Items[i].WWL);
                                    }
                                }

                                for (var i = 0; i < d.Item2.D.Items.length; i++) {
                                    d.Item2.D.Items[i].isChecked = false;
                                }
                                that.arr_reportList = d.Item2.D.Items;
                                that.int_TP = Math.max(d.Item2.D.TotalPages, 1);
                                //console.log("arr rpt list:");
                                //console.log(that.arr_mainReportList);
                                //console.log(that.arr_reportList);
                            } else {
                                that.arr_reportList = [];
                                that.totalBet = 0;
                                that.totalBetAmount = 0;
                                that.totalBetTurnover = 0;
                                that.totalBetWL = 0;
                                that.totalBetPWL = 0;
                                that.totalBetHWL = 0;
                            }

                            if (d.Item3) {
                                that.objPayoutScheme = d.Item3
                            }
                            that.resizeTableHead();
                        }
                        that.bool_fullLoading = false;
                    });
                this.ML_D = this.checkModuleAccess('ML', 'M', constAccessType.delete);
            },
            DisplayGPI(gpi, isDetails) {
                if (isDetails != null) {
                    this.searchGameProviderId = [gpi];
                    this.arr_displayGPI = [];
                    this.arr_displayGPI.push(gpi);
                    this.getReportList();
                }
            },
            saveToExcel() {
                this.bool_fullLoading = false;
                var path = "";

                var hasDefaultPath = false;
                path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                if (path) {
                    hasDefaultPath = true;
                }

                path += "&f.FSAR=true";

                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                    path += "&f.AGT=4";
                }
                else if (this.searchAgent) {
                    path += "&f.AGI=" + this.searchAgent.split("-")[1];
                    path += "&f.AGT=3";
                }

                if (this.searchUserId) {
                    path += "&f.MI=" + this.searchUserId;
                }

                if (this.searchReferralUserId) {
                    path += "&f.RI=" + this.searchReferralUserId;
                }

                if (this.searchGameCategoryIds) {
                    path += "&f.GCI_csv=" + this.searchGameCategoryIds;
                }

                if (this.searchGameProviderId) {
                    //path += "&f.GPI=" + this.searchGameProviderId;
                    path += "&f.GPI_csv=" + this.searchGameProviderId;
                }
                else {
                    this.arr_displayGPI = [];
                }

                if (this.searchCurrency && this.bool_firstLogin == true) {
                    path += "&f.CI=" + this.searchCurrency;
                }
                else if (localStorage.getItem('CCUSD') != "" && this.bool_firstLogin == false) {
                    path += "&f.CI=" + localStorage.getItem('CCUSD');
                    this.bool_firstLogin = true;
                }

                if (this.searchCurrencyFilter) {
                    path += "&f.CIF=" + this.searchCurrencyFilter;
                }

                if (this.searchCreatedTS) {

                    if (this.searchCreatedTS.startDate != "") {
                        path += "&f.STS_from=" + this.parseDateToJsonString(this.searchCreatedTS.startDate);
                    }

                    if (this.searchCreatedTS.endDate != "") {
                        path += "&f.STS_to=" + this.parseDateToJsonString(this.searchCreatedTS.endDate);
                    }

                }

                if (this.arr_displayGPI.length > 0) {
                    path += "&f.ID=1";
                }
                if (this.searchVDP) {
                    path += "&f.VDP=" + this.searchVDP;
                }
                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }

                window.open('/api/reports/winlossexcel/totalba?' + path, '_blank');
            },
            saveBlackList() {
                this.bool_fullLoading = true;
                var that = this;

                var dt = [];
                for (var i = 0; i < this.arr_reportList.length; i++) {
                    if (i == 0)
                        continue;

                    if (this.arr_reportList[i].isChecked) {
                        var subdt = {
                            I: this.arr_reportList[i].I,
                            UTS: this.arr_reportList[i].UTS,
                            BR: 'Total Win Loss Agent',
                            AGI: this.arr_reportList[i].AGI,
                            ICI: 0
                        };

                        dt.push(subdt);
                    }
                }

                this.postDataApi(`/api/m/bm`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                that.$fire({
                                    title: that.getLanguage["MEM"]["CA"],
                                    html: that.getLanguage["MEM"]["CICI"],
                                    width: '30em',
                                    showCancelButton: true,
                                    confirmButtonText: 'Ok',
                                    cancelButtonText: 'Cancel',
                                    reverseButtons: true,
                                    customClass: {
                                        title: 'afb-alert-title',
                                        content: 'afb-alert-content',
                                        actions: 'afb-alert-action'
                                    }
                                }).then((result) => {
                                    if (result.value == true) {
                                        that.bool_fullLoading = true;
                                        for (var i = 0; i < dt.length; i++)
                                            dt[i]['ICI'] = 1;
                                        that.postDataApi(`/api/m/bm`, dt,
                                            function (d, s) {
                                                that.bool_fullLoading = false;
                                                if (s) {
                                                    that.getReportList();
                                                }
                                            });
                                    }
                                });
                            }
                            else {
                                that.getReportList();
                            }
                        }
                    });
            },
            saveFreeze() {
                this.bool_fullLoading = true;
                var that = this;

                var dt = [];
                for (var i = 0; i < this.arr_reportList.length; i++) {
                    if (i == 0)
                        continue;

                    if (this.arr_reportList[i].isChecked) {
                        var subdt = {
                            I: this.arr_reportList[i].I,
                            UTS: this.arr_reportList[i].UTS,
                            FR: 'Total Win Loss Agent',
                            AGI: this.arr_reportList[i].AGI,
                            ICI: 0
                        };

                        dt.push(subdt);
                    }
                }

                this.postDataApi(`/api/m/fm`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 99) {
                                that.$fire({
                                    title: that.getLanguage["MEM"]["CA"],
                                    html: that.getLanguage["MEM"]["CICI"],
                                    width: '30em',
                                    showCancelButton: true,
                                    confirmButtonText: 'Ok',
                                    cancelButtonText: 'Cancel',
                                    reverseButtons: true,
                                    customClass: {
                                        title: 'afb-alert-title',
                                        content: 'afb-alert-content',
                                        actions: 'afb-alert-action'
                                    }
                                }).then((result) => {
                                    if (result.value == true) {
                                        that.bool_fullLoading = true;
                                        for (var i = 0; i < dt.length; i++)
                                            dt[i]['ICI'] = 1;
                                        that.postDataApi(`/api/m/fm`, dt,
                                            function (d, s) {
                                                that.bool_fullLoading = false;
                                                if (s) {
                                                    that.getReportList();
                                                }
                                            });
                                    }
                                });
                            }
                            else {
                                that.getReportList();
                            }
                        }
                    });
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            selectMemberOptions(node, instanceId) {
                if (this.ddMemberList && this.ddMemberList.length > 0) {
                    var index = -1;
                    for (var i = 0; i < this.ddMemberList.length; i++) {
                        if (this.ddMemberList[i].id == node) {
                            this.searchUsername = this.ddMemberList[i].label;
                            break;
                        }
                    }
                }
                else {
                    this.searchUsername = null;
                }
            },
            deSelectMemberOptions(node, instanceId) {
                this.searchUserId = null;
                this.searchUsername = null;
            },
            loadReferralMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddReferralMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${this.searchAgi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddReferralMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddReferralMemberList = [];
                            }

                            callback(null, that.ddReferralMemberList);
                        });
                }
            },
            selectReferralMemberOptions(node, instanceId) {
                // this.searchAgi = node.agi;
            },
            deSelectReferralMemberOptions(node, instanceId) {
                this.searchReferralUserId = null;
                this.searchReferralUsername = null;
            },
            getCurrencyList(currencyCode = "") {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddCurrencyList = d.dropdownlist;
                            if (that.ddCurrencyList.length > 0) {
                                if (localStorage.getItem('CCUSD') != "" || currencyCode != "") {
                                    for (var i = 0; i < that.ddCurrencyList.length; i++) {
                                        if (currencyCode != "" && that.ddCurrencyList[i].label == currencyCode) {
                                            that.searchCurrencyFilter = that.ddCurrencyList[i].id;
                                        }
                                        else if (currencyCode == "" && that.ddCurrencyList[i].id == localStorage.getItem('CCUSD')) {
                                            that.searchCurrency = that.ddCurrencyList[i].id;
                                        }
                                        if (that.searchCurrency != null && that.searchCurrencyFilter != null) {
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.ddCurrencyList = null;
                        }
                    });
            },
            updateCC() {
                if (this.searchCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.searchCurrency);
                }
            },
            //SignOff() {

            //    var searchAGI = null; var searchMI = null; var searchRI = null; var searchGPI = null; var searchCurrency = null;
            //    var searchCIF = null; var searchSTS_from = null; var searchSTS_to = null; var searchID = null;
            //    var agentGId = null;

            //    if (this.searchAgi != '') {
            //        agentGId = this.searchAgi;
            //    }
            //    if (agentGId) {
            //        searchAGI = agentGId;
            //    }
            //    if (this.searchUserId) {
            //        searchMI = this.searchUserId;
            //    }
            //    if (this.searchReferralUserId) {
            //        searchRI = this.searchReferralUserId;
            //    }
            //    if (this.searchGameProviderId) {
            //        searchGPI = this.searchGameProviderId;
            //    }
            //    if (this.searchCurrency) {
            //        searchCurrency = this.searchCurrency;
            //    }
            //    if (this.searchCurrencyFilter) {
            //        searchCIF = this.searchCurrencyFilter;
            //    }
            //    if (this.searchCreatedTS) {
            //        if (this.searchCreatedTS.startDate != "") {
            //            searchSTS_from = this.parseDateToJsonString(this.searchCreatedTS.startDate);
            //        }
            //        if (this.searchCreatedTS.endDate != "") {
            //            searchSTS_to = this.parseDateToJsonString(this.searchCreatedTS.endDate);
            //        }

            //    }

            //    if (this.arr_displayGPI.length > 0) {
            //        searchID = 1;
            //    }

            //    this.$fire({
            //        title: this.getLanguage["FR"]["SOFF"],//"Sign Off",
            //        width: '30em',
            //        showCancelButton: true,
            //        html: this.getLanguage["FR"]["SFMG"],//"Report cannot be modified after signed off. Please make sure all the amount is finalized before sign off. Are you confirm to sign off this report?",
            //        confirmButtonText: this.getLanguage["GL"]["YES"],
            //        cancelButtonText: this.getLanguage["CNO"]["NO"],
            //        reverseButtons: true,
            //        customClass: {
            //            title: 'afb-alert-title',
            //            content: 'afb-alert-content',
            //            actions: 'afb-alert-action'
            //        }
            //    }).then((result) => {

            //        if (result.value == true) {
            //            this.bool_fullLoading = true;
            //            var that = this;

            //            var dt = {
            //                f: {
            //                    AGI_csv: searchAGI,
            //                    MI: searchMI,
            //                    RI: searchRI,
            //                    GPI: searchGPI,
            //                    CI: searchCurrency,
            //                    CIF: searchCIF,
            //                    STS_from: searchSTS_from,
            //                    STS_to: searchSTS_to,
            //                    ID: searchID
            //                }
            //            };

            //            this.postDataApi(`/api/reports/winloss/totalba/soff`, dt,
            //                function (d, s) {
            //                    that.bool_fullLoading = false;
            //                    if (s) {
            //                        that.getReportList();
            //                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
            //                    }
            //                });

            //        }

            //    });
            //},
            calculateTWL(totalBetHWL, W1AC, TBA, TARA, TDLSA, TRA, TTA, TPA, ADPT) {
                var totalWNL = 0;
                var totalWL = totalBetHWL + W1AC;
                var totalCost = TBA + TARA + TDLSA + TRA + TTA + TPA;
                if (this.objPayoutScheme.WLT != null && this.objPayoutScheme.POT != null) {

                    if (this.objPayoutScheme.WLT == 1) {
                        if (totalWL < 0) {
                            totalWL = 0;
                        }
                    }

                    if (this.objPayoutScheme.POT == 2) {
                        totalCost = 0;
                    }
                    else if (this.objPayoutScheme.POT == 3) {
                        totalCost = totalCost * (ADPT/100);
                    }
                }

                totalWNL = totalWL - totalCost;

                return totalWNL;
            },
            clearDateRangeFilter() {
                this.searchCreatedTS.startDate = this.getMonthStartDate();
                this.searchCreatedTS.endDate = this.getMonthEndDate();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            changeAlllCheckBox() {
                if (this.arr_reportList[0].isChecked == true)
                    this.arr_reportList[0].isChecked = false;
                else
                    this.arr_reportList[0].isChecked = true;

                for (var i = 0; i < this.arr_reportList.length; i++) {
                    if (i == 0)
                        continue;

                    this.arr_reportList[i].isChecked = this.arr_reportList[0].isChecked;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getReportList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);

                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const allHeaderRows = this.$el.querySelectorAll('#tHead .custom-table thead tr');

                if (!allHeaderRows.length) return; // Early return if no header rows

                tables.forEach((table) => {
                    let tempLeft = 0;
                    let nestedIndex = 0;

                    // Collect body cells from the first row
                    const bodyCells = Array.from(table.querySelectorAll('tbody tr:first-child td'));
                    if (!bodyCells.length) return; // Early return if no body cells

                    // Reset all widths before applying new ones
                    const bodyCellElements = table.querySelectorAll('tbody tr td');
                    [...allHeaderRows[0].querySelectorAll('th'), ...bodyCellElements].forEach(cell => cell.style.width = '');

                    // Apply widths to header and body cells
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        const isNested = [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, , 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32].includes(index);
                        const headerRow = isNested ? 2 : 1;
                        const headerCells = this.$el.querySelectorAll(`#tHead .custom-table thead tr:nth-child(${headerRow}) th`);

                        let headerCell = headerCells[isNested ? nestedIndex : index];

                        // Special case for index 14
                        if (index === 14) {
                            headerCell = headerCells[8];
                        } else if (index === 33) {
                            headerCell = headerCells[17];
                        }


                        // Update header cell styles
                        if (headerCell) {
                            headerCell.style.width = width;
                            if (!isNested && index < 3) {
                                headerCell.style.left = `${tempLeft}px`;
                                headerCell.style.zIndex = `3`;
                            }
                        }

                        // Update body cell styles for the corresponding column
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach((td) => {
                            td.style.width = width;
                            if (!isNested && index < 3) {
                                td.style.left = `${tempLeft}px`;
                                td.style.zIndex = `3`;
                            }
                        });

                        // Increment nestedIndex for nested columns
                        tempLeft += parseFloat(width);
                        if (isNested) nestedIndex++;
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            MarginCal(winloss, turnover) {
                var formatWinloss = this.formatNumber(winloss);
                var formatTurnover = this.formatNumber(turnover);
                formatWinloss = Number(formatWinloss.toString().replaceAll(',', ''));
                formatTurnover = Number(formatTurnover.toString().replaceAll(',', ''));
                var result = (formatWinloss / formatTurnover) * -100;
                return result;
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserMemberSC', 'getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS3';
            this.$parent.showActiveMenu = 'R.SAGTWL';

            this.hideBrand = this.getUserInfo.IHAGIF;

            if (this.$route.query.agi) {
                this.searchAgent = this.$route.query.agi;
            }
            if (this.$route.query.gpi > 0) {
                this.searchGameProviderId = ($.isArray(this.$route.query.gpi) ? this.$route.query.gpi : [this.$route.query.gpi]);
            }
            if (this.$route.query.mi > 0) {
                this.searchUserId = this.$route.query.mi;
            }
            if (this.$route.query.ri > 0) {
                this.searchReferralUserId = this.$route.query.ri;
            }
            if (this.$route.query.ccur > 0) {
                this.searchCurrency = this.$route.query.ccur;
            }
            if (this.$route.query.curf > 0) {
                this.searchCurrencyFilter = this.$route.query.curf;
            }else {
                this.getCurrencyList();
            }
            
            if (this.$route.query.df) {
                this.searchCreatedTS.startDate = this.$route.query.df;
            }
            if (this.$route.query.dt) {
                this.searchCreatedTS.endDate = this.$route.query.dt;
            }
            if (this.$route.query.sagi > 0) {
                this.loadDefaultSubBrand(this.$route.query.sagi);
            }
            else {
                this.getReportList();
            }

            //if (this.$route.path != this.$route.fullPath)
            //    this.getReportList();
        },
        watch: {
            getLanguage() {
                this.getReportList();
            },
        },
    }
</script>

<style>

   /* .negative-number span {
        color: #e55353 !important;
    }*/
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/NewTotalWinLossSAG.vue